export default __webpack_public_path__ + "static/media/Image-9.fb4578fa.jpg";